<a
  mat-button
  [class]="
    [
      design,
      size,
      outlined ? 'outlined' : '',
      disabled ? 'disabled' : '',
      rounded ? 'rounded' : '',
      class
    ].join(' ')
  "
  [href]="href"
  [target]="openNewTab ? '_blank' : ''"
>
  <ng-content></ng-content>
</a>
